/* Global site navigation shared by student and faculty pages. */
import React, { useState, useEffect, useRef } from "react";

import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import APIService from "../APIService";
import ToggleDarkMode from "./ToggleDarkMode";

function NavBar() {
  const [hasFacultyAccess, setHasFacultyAccess] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const checkPrimaryAttribute = async () => {
      try {
        const data = await APIService.GetUserPrimaryAttribute();
        setHasFacultyAccess(Boolean(data?.faculty_access));
      } catch (error) {
        console.error("Failed to fetch user primary attribute", error);
      }
    };

    checkPrimaryAttribute();
  }, []);

  useEffect(() => {
    const updateHeaderHeight = () => {
      // Layouts offset their main content using this CSS variable.
      const nextHeight = navbarRef.current?.offsetHeight || 52;
      document.documentElement.style.setProperty("--app-header-height", `${nextHeight}px`);
    };

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);

    return () => {
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, []);

  return (
    <Navbar ref={navbarRef} as="header" expand="xxl" className="custom-navbar">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <div className="container-fluid">
        <Navbar.Brand as={Link} to="/" className="miami-ai-tutor-navbar-brand">Miami AI Tutor</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" aria-label="Toggle site navigation" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto navbar-items" aria-label="Primary">
            <Nav.Link as={Link} to="/">Chat</Nav.Link>
            <Nav.Link as={Link} to="/history">History</Nav.Link>
            {hasFacultyAccess && (
              <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
            )}
            <NavDropdown
              title={<span className="navbar-menu-trigger" aria-hidden="true">☰</span>}
              id="basic-nav-dropdown"
              align="end"
              aria-label="Menu"
            >
              <NavDropdown.Item as={Link} to="/help">Help</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/feedback">Feedback</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.ItemText className="navbar-menu-toggle-row">
                <ToggleDarkMode compact />
              </NavDropdown.ItemText>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/profile">Profile</NavDropdown.Item>
	            <NavDropdown.Item onClick={APIService.Logout}>Logout</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}

export default NavBar;
